import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-it-works-football',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-football.component.html',
  styleUrl: './how-it-works-football.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksFootballComponent {
  protected readonly sliderOptions = sliderOptions;
}
